import IUser from "../entities/IUser";

export const getUserId = (user: Partial<IUser> & { [key: string]: any }): number => {
  if (!user) return 0;
  const candidate = user.userId ?? user.id ?? user.user_id ?? user.userID;
  const num = Number(candidate);
  return Number.isFinite(num) ? num : 0;
};
